import isMobileOrIpad from '@anm/helpers/is/isMobileOrIPad';
import { FC } from 'react';
import ShareVideo from '../../hosting/CustomizationSection/ShareVideo';
import Navigation from '../../../components/Navigation';
import { ShareBtnWrapper } from './styles';

type WebinarHeaderProps = {
  webinarId: string;
};

const WebinarHeader: FC<WebinarHeaderProps> = ({ webinarId }) => (
  <Navigation
    variant="lives"
    hideMyProjectsButton={true}
    hasShadow
    {...(!isMobileOrIpad() && {
      renderInnerContent: () => (
        <ShareBtnWrapper>
          <ShareVideo isWebinar hostId={webinarId} />
        </ShareBtnWrapper>
      )
    })}
  />
);

export default WebinarHeader;
